// extracted by mini-css-extract-plugin
module.exports = {"leaflet-control-custom":"MapColorInfo_leaflet-control-custom__uXRE9"};